import { Component, OnInit } from '@angular/core';
import { CmsInfoItemsProvider } from '@common/components/info/cms-info-items-provider';
import { CommunityService } from '@common/services/community.service';
import { LanguageService } from '@common/services/language.service';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-testimonials',
    templateUrl: './testimonials.component.html',
    styleUrls: ['./testimonials.component.scss'],
    standalone: false
})
export class TestimonialsComponent implements OnInit {
    $readMoreBtnUrl: Observable<string>;

    constructor(
        private communityService: CommunityService,
        private languageService: LanguageService,
        private cmsInfoItemsProvider: CmsInfoItemsProvider,
    ) {}

    ngOnInit(): void {
        this.$readMoreBtnUrl = combineLatest([
            this.communityService.currentAuctionOpenForDecisions$,
        ]).pipe(
            map((openForDecisions) => {
                const suffix = openForDecisions
                    ? 'acceptation'
                    : 'registration';

                const item = this.cmsInfoItemsProvider
                    .GetItems(suffix)
                    .find((i) => i.id === 'reviews');

                return !item
                    ? null
                    : `/${this.communityService.communityCode}/${
                          this.languageService.currentLanguageCode
                      }/info/${item.url ? item.url : item.id}`;
            }),
        );
    }
}
